import { isAfter } from 'date-fns';
import { useContext } from 'react';
import { postCoupon } from 'src/libs/api/couponApi';
import type { User } from 'src/libs/wa/models/entities/User';
import { AuthContext } from 'src/stores/Auth';
import { I18nContext } from 'src/stores/I18n';
import { getIssuedCouponStatus, setIssuedCouponStatus } from 'src/utils/cookies';
import { REGISTERED_VIA } from 'src/utils/registeredVia';
import { useModal } from './useModal';

export const useAddCoupon = () => {
  const { setIsVisible: setIssuedCouponModalVisible } = useModal('issuedCouponModal');
  const { setIsVisible: setLoginModalVisible, setModalParams: setLoginModalParams } = useModal('loginModal');
  const { setIsVisible, setModalParams } = useModal('noticeModal');
  const { user } = useContext(AuthContext);
  const localeResources = useContext(I18nContext);

  // 会員登録キャンペーンクーポン
  const execAddRegisteredCoupon = async (user: User) => {
    /*
    * 以下の条件でクーポンを付与する
    ①登録日時が現在時刻から1時間以内である場合
    ②registeredViaがkaimono_webの場合
    ③cookieにクーポン付与済みフラグがない
    */
    const now = new Date();
    const dueDate = new Date(now.getTime() - 60 * 60 * 1000);
    if (
      isAfter(user.createdAt, dueDate) &&
      user.registeredVia === REGISTERED_VIA.KAIMONO &&
      getIssuedCouponStatus() !== 'true'
    ) {
      const res = await postCoupon(process.env.NEXT_PUBLIC_NEW_MEMBER_COUPON_CODE);
      if (res.isRight()) {
        setIssuedCouponModalVisible(true);
        setIssuedCouponStatus('true');
      }
    }
  };
  // 全員キャンペーンクーポン
  const execAddAllUserCoupon = async () => {
    const res = await postCoupon(process.env.NEXT_PUBLIC_ALL_USER_COUPON_CODE);
    if (res.isRight()) {
      setIssuedCouponModalVisible(true);
    }
    if (res.isLeft()) {
      setModalParams({
        type: 'warning',
        text: res.value.errors.join(',')
      });
      setIsVisible(true);
    }
  };

  const execAddCouponByCode = async (promoCode: string) => {
    if (!user) {
      setLoginModalParams({
        title: localeResources.coupons.list.pleaseLogin
      });
      setLoginModalVisible(true);
      return;
    }
    const res = await postCoupon(promoCode);
    if (res.isLeft()) {
      setModalParams({
        type: 'warning',
        text: res.value.errors.join(',')
      });
      setIsVisible(true);
      return;
    }
    setIssuedCouponModalVisible(true);
  };

  return {
    execAddRegisteredCoupon,
    execAddAllUserCoupon,
    execAddCouponByCode
  };
};
